import api from '../lib/api';

const reportService = {
    getReports: async (params) => {
        try {
            const response = await api.get('/reports', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching reports:', error);
            throw error;
        }
    },

    getReport: async (reportId) => {
        try {
            const response = await api.get(`/reports/${reportId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching report:', error);
            throw error;
        }
    },

    generateUserReport: async (params) => {
        try {
            const response = await api.post('/reports/user-activity', params);
            return response.data;
        } catch (error) {
            console.error('Error generating user report:', error);
            throw error;
        }
    },

    generateAuctionReport: async (params) => {
        try {
            const response = await api.post('/reports/auction-performance', params);
            return response.data;
        } catch (error) {
            console.error('Error generating auction report:', error);
            throw error;
        }
    },

    generateBidReport: async (params) => {
        try {
            const response = await api.post('/reports/bid-analysis', params);
            return response.data;
        } catch (error) {
            console.error('Error generating bid report:', error);
            throw error;
        }
    },

    deleteReport: async (reportId) => {
        try {
            const response = await api.delete(`/reports/${reportId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting report:', error);
            throw error;
        }
    }
};

export default reportService; 